import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24 8H8v2.67h16V8ZM8 16v2.67h5.73c.25-.96.64-1.86 1.17-2.67H8Zm0-1.33h7.97C17.58 13.03 19.82 12 22.31 12H8v2.67ZM12.65 21.33H6.89L5.33 22.89V5.33h21.33v7.81c1.04.59 1.94 1.38 2.67 2.32V5.33C29.33 3.86 28.13 2.66 26.66 2.66H5.33C3.86 2.66 2.68 3.86 2.68 5.33v24l5.32-5.33h6.02c-.32-.84-.51-1.73-.55-2.67h-.83Z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "22.5",
  cy: "21.22",
  r: "7.86",
  fill: "#4EA900"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFFF",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.93 25.21l-3.44-3.44 1.38-1.38 2.06 2.06 5.21-5.21 1.38 1.38-6.59 6.59Z"
})), 'ChatSuccess', {
  viewBox: '0 0 16 16'
});